import type { WebappAttribution } from './attribution.types';
import type { GoogleLoginResponse } from './google-login.types';

const PROD_API_URL =
  'https://dxpuw6f7o9.execute-api.eu-central-1.amazonaws.com/dev/';

function getBaseUrl(): string {
  const isDevServer =
    import.meta.env.DEV && window.location.protocol === 'http:';
  if (isDevServer) return '';
  return import.meta.env.VITE_API_URL ?? PROD_API_URL;
}

export async function googleLogin(
  credential: string,
  attribution?: WebappAttribution,
): Promise<GoogleLoginResponse> {
  const base = getBaseUrl().replace(/\/$/, '');
  const response = await fetch(`${base}/api/v1/auth/login/google`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    // attribution is only sent when present; the backend stamps it solely on
    // brand-new user creation.
    body: JSON.stringify(attribution ? { credential, attribution } : { credential }),
  });

  if (!response.ok) {
    const body = await response.text();
    throw new Error(`Google login failed (${response.status}): ${body}`);
  }

  return (await response.json()) as GoogleLoginResponse;
}
